module.exports = __webpack_public_path__ + "img/beijing.e683356c.png";